import { lazy } from 'react';

import { retry } from 'app/utils/lib/file';

type ComponentProps = Record<string, unknown>;

// Lazy-loaded components
const LazyPayorsListRoute = lazy(() => retry(() => import('app/pages/admin/Payors/List')));
const LazyPayorsNewRoute = lazy(() => retry(() => import('app/pages/admin/Payors/New')));
const LazyPayorsEditRoute = lazy(() => retry(() => import('app/pages/admin/Payors/Edit')));
const LazyPayorsShowRoute = lazy(() => retry(() => import('app/pages/admin/Payors/Show')));

// Export component wrappers
export const PayorsList = (props: ComponentProps) => <LazyPayorsListRoute {...props} />;
export const PayorsNew = (props: ComponentProps) => <LazyPayorsNewRoute {...props} />;
export const PayorsEdit = (props: ComponentProps) => <LazyPayorsEditRoute {...props} />;
export const PayorsShow = (props: ComponentProps) => <LazyPayorsShowRoute {...props} />;
